const env = process.env.REACT_APP_ENV ;
console.log("env",env)

let redirectUri = 'http://localhost:3000';
let dakikaBaseUrl = 'https://test.dakika.com.tr';
let oAuth2Url = 'https://test-login.dakika.com.tr';
let galleryRedirect ='http://localhost:3000';

  if (env === 'dev') {
  redirectUri = 'https://dev-glasshouse-masraf.dakika.com.tr';
  oAuth2Url = 'http://dev.sso-service.dtst.k8s';
  dakikaBaseUrl = 'https://dev.dakika.com.tr';
  galleryRedirect = 'https://dev-gallery.dakika.com.tr/';
  } else if (env === 'test') {
  redirectUri = 'https://testmasraf.dakika.com.tr';
  oAuth2Url = 'https://test-login.dakika.com.tr';
  dakikaBaseUrl = 'https://test.dakika.com.tr';
  galleryRedirect = 'https://test-gallery.dakika.com.tr';
  } else if (env === 'production') {
  redirectUri = 'https://masraf.dakika.com.tr';
  oAuth2Url = 'https://login.dakika.com.tr';
  dakikaBaseUrl = 'https://app.dakika.com.tr';
  galleryRedirect = 'https://gallery.dakika.com.tr';
}

export default{
  url: oAuth2Url,
  authorizationPath: '/oauth/authorize',
  checkUserPath: '/oauth/user',
  clientId: 'dakika3g-fe',
  redirectUri,
  dakikaBaseUrl,
  responseType: 'code',
  scope: 'uid',
  galleryRedirect
};
